import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import { TOGGLE_COMING_SOON_MODAL } from 'components/Pages/Home/actions.js';
import { Send } from 'components/Global/MenuItems';
import BookmarkContentButton from 'components/Global/BookmarkContent/BookmarkContentButton.jsx';
import { StyledMenuContainer } from './styled.js';

const CardMenu = forwardRef(({ bookmarked, id, toggleComingSoonModal, setLocalBookmark }, ref) => (
  <StyledMenuContainer ref={ref}>
    <Send callback={() => toggleComingSoonModal()} />
    <BookmarkContentButton bookmarked={bookmarked} id={id} setLocalBookmark={setLocalBookmark} />
  </StyledMenuContainer>
));

const mapDispatchToProps = (dispatch) => ({
  toggleComingSoonModal: () => dispatch({ type: TOGGLE_COMING_SOON_MODAL, modal: 'comingSoonContentSharing' }),
});

// We are forwardRef twice, to forward through connect() as well as the functional CardMenu component
const CardMenuWithRef = forwardRef((props, ref) => (
  <CardMenu {...props} ref={ref} />
));

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(CardMenuWithRef);

